import React, { useContext, useEffect, useRef, useState } from "react";
import { Title } from "../../../../../../stories/Title/Title";
import { Label } from "../../../../../../stories/Label/Label";
import Close from "../../../../../../images/Close.svg";
import Input from "../../../../../../stories/Input/Input";
import TextArea from "../../../../../../stories/TextArea/TextArea";
import { Keys } from "../../../../../../utils/Enum.keys";
import {
  EMPTY_STRING,
  ROWS_PER_PAGE,
  TEXTAREA,
  emptyFunc,
  emptyMessage,
} from "../../../../../../utils/constants";
import useLabels from "../../../../../../customHooks/useLabels";
import JunctionsAutocomplete from "../../../../../../customComponents/JunctionsAutocomplete";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../../styles/AutocompleteStyles";
import { TextField } from "@mui/material";
import EmployeeSelect from "../../../../../../customComponents/EmplayeeSelect";
import {
  Operation,
  PriorityEnum,
  empType,
} from "../../../../../../utils/Enum.types";
import { EmpMaster, EmpQueryType } from "../../../users/queries/types";
import { responseType } from "../../../../../../utils/formTypes";
import SiteSelect from "../../../../../../customComponents/SiteSelect";
import { Button } from "../../../../../../stories/Button/Button";
import { MapsContext } from "../../../maps/context/context";
import { TableType } from "../../../../customer/companies/queries/types";
import { useLazyQuery, useMutation } from "@apollo/client";
import {
  OrderDirection,
  nodeVar,
} from "../../../../../../utils/commonQueryTypes";
import { AtsTicketsByNodeData } from "../../../masters/items/queries/queries";
import { GetTicketByNode } from "./queries/queries";
import { mapsPayloadType } from "../../../maps/context/reducer";
import { UpdateTicketDetailsVar, UpdateTicketResult } from "./queries/types";
import { UpdateTicket } from "./queries/mutation";
import useUrlParams from "../../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../../customHooks/useLoggedInUserDetails";
import { GetEmpMasterByNodeId } from "../../../users/queries/queries";
import JunctionDetails from "../../../maps/ticketing/junctionDetails/JunctionDetails";
import { msgType } from "../../../../../../utils/types";
import MessageModal from "../../../../../../customComponents/MessageModal";
import { GetTickets } from "../../../../../../queries/queries";
import {
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../../queries/types";
import TicketReasonSelect from "../../../../../../customComponents/TicketReasonSelect";

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}

interface initialTicketDatilsInterface {
  reason: string;
  remarks: string;
  tableLevel: TableType;
  itemDetailsID: number;
  siteID: number;
  junctionID: number;
  img: string;
}

interface UserType {
  kgid: number;
  name: string;
  mobile: string;
  designation: string;
}

const EditTicket = ({ setModalFlag }: Props) => {
  const initialTicketDatils = {
    reason: "",
    remarks: "",
    tableLevel: TableType.NONE,
    itemDetailsID: 0,
    siteID: 0,
    junctionID: 0,
    img: "item",
  };
  const [formData, setFormData] =
    useState<initialTicketDatilsInterface>(initialTicketDatils);
  const { subsidiarySiteLabel, junctionLabel, itemLabel } = useLabels();
  const { customer_id } = useUrlParams();
  const { user_details } = useLoggedInUserDetails();
  const [selectedCompaint, setSelectedCompaint] = useState("");
  const [selectedEmp, setSelectedEmp] = useState<responseType | null>(null);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const [user, setUser] = useState<UserType>({
    kgid: 0,
    name: "",
    mobile: "",
    designation: "",
  });
  const { state, dispatch } = useContext(MapsContext);
  const [junction, setJunction] = useState({
    name: "",
    code: "",
    alias: "",
    jType: "",
    arms: 0,
    icon: "",
    maintained_by: "",
  });
  const ref = useRef<HTMLInputElement | null>(null);

  const [getTicketByNode, { data }] = useLazyQuery<
    AtsTicketsByNodeData,
    nodeVar
  >(GetTicketByNode);

  const [GetEmpById] = useLazyQuery<{ node: EmpMaster }, nodeVar>(
    GetEmpMasterByNodeId
  );

  const [updateTicket] = useMutation<
    UpdateTicketResult,
    UpdateTicketDetailsVar
  >(UpdateTicket, {
    onError: (e) => {
      setMessage({
        flag: true,
        message: e.message,
        operation: Operation.NONE,
      });
    },
  });

  useEffect(() => {
    if (state.ticketId) {
      getTicketByNode({
        variables: {
          id: state.ticketId,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          let img = "";
          if (data.node.tableLevel === TableType.JUNCTION) {
            img = require(`../../../../../../images/ItemIcons/${
              data.node.junction.icon ? data.node.junction.icon : "junction"
            }.svg`);
          } else {
            img = require(`../../../../../../images/ItemIcons/${
              data.node.item?.icon ? data.node.item.icon : "item"
            }.svg`);
          }

          setFormData({
            reason: data.node.reason,
            remarks: data.node.openRemarks,
            tableLevel: data.node.tableLevel,
            itemDetailsID: data.node.itemDetails.id,
            siteID: data.node.site.id,
            junctionID: data.node.junction.id,
            img,
          });
          setSelectedEmp({
            label: data.node.loggedUser.name,
            value: data.node.loggedUser.id,
          });
          setSelectedCompaint(
            data.node.loggedUser
              ? data.node.loggedUser.empType === empType.VENDOR_MANAGER
                ? "Vendor"
                : "Police"
              : "Others / Public"
          );

          if (data.node.junction) {
            setJunction({
              name: data.node.junction.name,
              code: data.node.junction.code,
              alias: data.node.junction.alias,
              jType: data.node.junction.jType,
              arms: data.node.junction.arms,
              icon: require(`../../../../../../images/ItemIcons/${
                data.node.junction?.icon ? data.node.junction.icon : "item"
              }.svg`),
              maintained_by: data.node.junction.vendorDetails.desc,
            });
          }

          dispatch({
            type: mapsPayloadType.ASSET_TYPE_ID,
            payload: { assetTypeId: data.node.junction.id },
          });
        }
      });
    }
  }, [state.ticketId, getTicketByNode]);

  const handlesubmit = () => {
    if (!formData.reason) {
      return setMessage({
        flag: true,
        message: "Reason is Required",
        operation: Operation.NONE,
      });
    }
    if (customer_id && state.ticketId) {
      updateTicket({
        variables: {
          customerID: customer_id ? customer_id : 0,
          user_details,
          input: {
            itemDetailsID: formData.itemDetailsID,
            junctionID: state.assetTypeId
              ? state.assetTypeId
              : formData.junctionID,
            reason: formData.reason,
            remarks: formData.remarks,
            siteID: formData.siteID,
            tableLevel: formData.tableLevel,
            loggedBy: selectedEmp?.value ? selectedEmp?.value : 0,
          },
          ticketID: state.ticketId,
        },
        refetchQueries: [
          {
            query: GetTickets,
            variables: {
              after: null,
              first: ROWS_PER_PAGE,
              name: EMPTY_STRING,
              orderBy: {
                direction: OrderDirection.ASC,
                field: AtsTicketsOrderField.TICKET_NO,
              },
              companyID: 0,
              customerID: customer_id,
              subsidiaryID: 0,
              reason: EMPTY_STRING,
              startDate: undefined,
              endDate: undefined,
              input: {
                itemID: 0,
                ldgrID: 0,
                stckCategoryID: 0,
                stckGroupID: 0,
                stckManufacturerID: 0,
                stckSubCategoryID: 0,
                stckUomID: 0,
                query_type: TicketsQueryType.ALL,
                itemDetailsID: 0,
                status: [],
                priority: [],
                empID: user_details.id!,
              },
              siteID: 0,
              junctionID: 0,
            },
          },
        ],
      }).then(({ data }) => {
        if (data) {
          setMessage({
            flag: true,
            message: "Updated successfully",
            operation: Operation.UPDATE,
          });
        }
      });
    }
  };

  useEffect(() => {
    if (selectedEmp?.value) {
      GetEmpById({
        variables: {
          id: selectedEmp?.value ? selectedEmp?.value : 0,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setUser({
            kgid: data.node?.kgid,
            name: data.node?.name,
            mobile: data.node?.mobile,
            designation: data.node?.empType,
          });
        }
      });
    }
  }, [GetEmpById, selectedEmp?.value]);

  const handleClear = () => {
    dispatch({
      type: mapsPayloadType.ASSET_TYPE_ID,
      payload: {
        assetTypeId: 0,
      },
    });
    setSelectedCompaint("");
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
    }
    setMessage(emptyMessage);
    if (message.operation === Operation.UPDATE) {
      setModalFlag(false);
    }
  };

  const selectUser = () => {
    return (
      <div>
        {selectedCompaint === "Police" && (
          <div className="label-grid">
            <Label>Metal No / KgId :</Label>
            <EmployeeSelect
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedEmp(newValue);
                } else {
                  setSelectedEmp(null);
                }
              }}
              empType={[
                empType.ACP,
                empType.ASI,
                empType.DCP,
                empType.JCP,
                empType.PC,
                empType.PSI,
                empType.WPC,
                empType.WPSI,
                empType.HC,
                empType.WHC,
                empType.WASI,
                empType.PMU
              ]}
              onKeyDown={emptyFunc}
              queryType={EmpQueryType.BY_TYPE}
              value={
                selectedEmp
                  ? selectedEmp.value
                  : data?.node
                  ? data?.node.loggedUser.id
                  : 0
              }
              label=""
              ldgrId={0}
              kgid={true}
            />
          </div>
        )}

        <div className="label-grid">
          <Label>Name :</Label>
          {selectedCompaint === "Vendor" ? (
            <EmployeeSelect
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedEmp(newValue);
                } else {
                  setSelectedEmp(null);
                }
              }}
              empType={[empType.VENDOR_MANAGER]}
              onKeyDown={emptyFunc}
              queryType={EmpQueryType.BY_TYPE}
              value={
                selectedEmp
                  ? selectedEmp.value
                  : data?.node
                  ? data?.node.loggedUser.id
                  : 0
              }
              label=""
              ldgrId={0}
            />
          ) : (
            <Input value={user.name} disabled />
          )}
        </div>
        <div className="label-grid">
          <Label>Designation :</Label>
          <Input value={user.designation} disabled />
        </div>
        <div className="label-grid">
          <Label>Mobile No :</Label>
          <Input value={user.mobile} disabled />
        </div>
      </div>
    );
  };

  return (
    <>
      <div className="edit-tkt-details">
        <div className="edit-tkt-details__title">
          <Title>Edit Ticket Details</Title>
          <img
            src={Close}
            alt=""
            onClick={() => {
              setModalFlag(false);
            }}
          />
        </div>
        <div className="edit-tkt-details__tkt-no">
          <Label>Ticket No</Label> :{" "}
          <b className="bg-red">{data?.node.ticketNo}</b>
        </div>
        <div className="edit-tkt-details__data row g-0">
          <div className="col edit-tkt-details__data--previous">
            <div className="edit-tkt-details__data--header">
              <h4>Previous Ticket Details</h4>
            </div>
            {data && data.node && (
              <>
                <div className="label-grid">
                  <Label>{junctionLabel} :</Label>
                  <Input
                    value={`${data.node.junction.code} (${data.node.junction.name})`}
                    disabled
                  />
                </div>

                <>
                  <div className="edit-tkt-details__data--path ">
                    {data.node.company.name}{" "}
                    <span className="font-blue">/</span>{" "}
                    {data.node.subsidiaryDetails.name}{" "}
                    <span className="font-blue">/</span> {data.node.site.name}
                  </div>

             
                  <div className="maps-item-details__asset--h">
                    <div
                      className={`maps-item-details__asset--h--flex ${
                        data.node.priority === PriorityEnum.CRITICAL
                          ? "border-red"
                          : data.node.priority === PriorityEnum.MEDIUM
                          ? "border-yellow"
                          : data.node.priority === PriorityEnum.LOW
                          ? "border-green"
                          : ""
                      }`}
                    >
                      <img src={junction.icon} alt="" />
                      <div>
                        <b className="maps-item-details__asset--h--item">
                          {junction.name}
                        </b>

                        <div className="maps-item-details__asset--h--span">
                          <span>{junction.jType},</span>
                          <span> {junction.arms} Arms</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </>

                <div className="edit-tkt-details__data--block">
                  <div className="label-grid">
                    <Label>Ticket Reason :</Label>
                    <Input value={data.node.reason} disabled />
                  </div>
                  <div className="label-grid">
                    <Label>Complaint Description :</Label>
                    <Input value={data.node.openRemarks} disabled />
                  </div>
                  <div className="label-grid">
                    <Label>Complaint Given By :</Label>
                    <Input
                      value={
                        data.node?.loggedUser.empType
                          ? data.node?.loggedUser.empType ===
                            empType.VENDOR_MANAGER
                            ? "Vendor"
                            : "Police"
                          : "Public"
                      }
                      disabled
                    />
                  </div>
                  {data.node.loggedUser && (
                    <>
                      <div className="label-grid">
                        <>
                          <Label>Name :</Label>
                          <Input value={data.node.loggedUser.name} disabled />
                        </>
                        <>
                          <Label>Metal No / KgId :</Label>
                          <Input value={data.node.loggedUser.kgid} disabled />
                        </>
                        <>
                          <Label>Designation :</Label>
                          <Input
                            value={data.node.loggedUser.empType}
                            disabled
                          />
                        </>
                        <>
                          <Label>Mobile No :</Label>
                          <Input value={data.node.loggedUser.mobile} disabled />
                        </>
                      </div>
                    </>
                  )}
                </div>
              </>
            )}
          </div>
          <div className="col edit-tkt-details__data--new">
            <div className="edit-tkt-details__data--new-header">
              <h4>Previous Ticket Details</h4>
            </div>
            {state.raiseTicketLevel === TableType.ASSET ? (
              <>
                <div className="label-grid">
                  <Label>{subsidiarySiteLabel}</Label>
                  <SiteSelect
                    onChange={(newValue) => {
                      if (newValue) {
                        setFormData({
                          ...formData,
                          siteID: newValue.value,
                        });
                      } else {
                        setFormData({
                          ...formData,
                          siteID: 0,
                        });
                      }
                    }}
                    companyId={data?.node ? data?.node.company.id : 0}
                    subsidiaryId={
                      data?.node ? data?.node.subsidiaryDetails.id : 0
                    }
                    onKeyDown={emptyFunc}
                    value={
                      formData.siteID
                        ? formData.siteID
                        : data?.node
                        ? data?.node.subsidiaryDetails.id
                        : 0
                    }
                    label={""}
                  />
                </div>
                <div className="label-grid">
                  <Label>{itemLabel} Details</Label>
                  {/* <ItemsDetailsAutocomplete
                      onChange={(newValue) => {
                        if (newValue) {
                          // setConfigIds({
                          //   ...configIds,
                          //   itemDetailsId: newValue.value,
                          // });
                          // dispatch({
                          //   type: mapsPayloadType.ASSET_TYPE_ID,
                          //   payload: { assetTypeId: newValue.value },
                          // });
                          // setRaiseTicketPage(true);
                          // setAssetType(TableType.ASSET);
                        } else {
                          // setConfigIds({
                          //   ...configIds,
                          //   itemDetailsId: 0,
                          // });
                          // dispatch({
                          //   type: mapsPayloadType.ASSET_TYPE_ID,
                          //   payload: { assetTypeId: 0 },
                          // });
                        }
                      }}
                      onKeyDown={emptyFunc}
                      // value={configIds.itemDetailsId}
                      value={0}
                      input={{
                        query_type: ItemDetailsQueryType.ALL,
                        stckCategoryID: 0,
                        stckGroupID: 0,
                        stckManufacturerID: 0,
                        stckUomID: 0,
                        stckSubCategoryID: 0,
                        itemID: configIds.itemId,
                        ldgrID: 0,
                        poleNum: 0,
                      }}
                      queryInput={{
                        companyID: configIds.companyId,
                        customerID: customer_id!,
                        junctionID: configIds.junctionId,
                        siteID: configIds.siteId,
                        subsidiaryID: configIds.subId,
                      }}
                      label=""
                    /> */}
                </div>{" "}
              </>
            ) : (
              ""
            )}

            {state.raiseTicketLevel === TableType.JUNCTION ? (
              <div className="label-grid">
                <Label>{junctionLabel}</Label>
                <JunctionsAutocomplete
                  label=""
                  onChange={(newValue) => {
                    if (newValue) {
                      dispatch({
                        type: mapsPayloadType.ASSET_TYPE_ID,
                        payload: { assetTypeId: newValue.node.id },
                      });
                    } else {
                      dispatch({
                        type: mapsPayloadType.ASSET_TYPE_ID,
                        payload: { assetTypeId: 0 },
                      });
                    }
                  }}
                  onKeyDown={emptyFunc}
                  value={state.assetTypeId ? state.assetTypeId : 0}
                />
              </div>
            ) : (
              ""
            )}

            {data && state.assetTypeId ? (
              <>
                <div className="edit-tkt-details__data--path">
                  {data.node.company.name} <span className="font-blue">/</span>{" "}
                  {data.node.subsidiaryDetails.name}{" "}
                  <span className="font-blue">/</span> {data.node.site.name}
                </div>
                {state.assetTypeId ? (
                  <JunctionDetails
                    assetType={TableType.JUNCTION}
                    viewIcon={true}
                  />
                ) : null}
              </>
            ) : null}
            <div className="edit-tkt-details__data--block">
              <div className="label-grid">
                <Label>Ticket Reason :</Label>
                <TicketReasonSelect
                  onChange={(newValue) => {
                    if (newValue) {
                      setFormData({
                        ...formData,
                        reason: newValue,
                      });
                    } else {
                      setFormData({
                        ...formData,
                        reason: newValue,
                      });
                    }
                  }}
                  value={formData.reason}
                />
              </div>
              <div className="label-grid">
                <Label>Complaint Description :</Label>
                <TextArea
                  rows={3}
                  name="remarks"
                  value={formData.remarks}
                  onChange={(e) => {
                    setFormData({
                      ...formData,
                      remarks: e.target.value,
                    });
                  }}
                  required
                />
              </div>
              <div className="label-grid">
                <Label>Compaint Given By :</Label>
                <FormAutocomplete
                  className={formClasses.inputRoot}
                  options={["Police", "Vendor", "Others / Public"]}
                  onKeyDown={emptyFunc}
                  value={selectedCompaint}
                  openOnFocus
                  forcePopupIcon
                  // getOptionLabel={(option) =>
                  //   (option as AtsCompanyEdge).node.name
                  // }
                  // slotProps={{
                  //   listbox: {
                  //     onScroll: handleScroll,
                  //   },
                  // }}
                  onChange={(e, newValue) => {
                    if (newValue) {
                      setSelectedCompaint(newValue as string);
                      if (newValue === "Others / Public") {
                        setSelectedEmp(null);
                      }
                    } else {
                      setSelectedCompaint("");
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      fullWidth
                      label=""
                      // autoFocus={autoFocus}
                      onChange={(e) => {}}
                      className={formClasses.formControlRoot}
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      placeholder={"Select"}
                    />
                  )}
                />
              </div>
              {selectedCompaint === "Police" || selectedCompaint === "Vendor"
                ? selectUser()
                : ""}
            </div>
          </div>
        </div>
        <Button mode="save" onClick={handlesubmit} />
        <Button
          mode="cancel"
          onClick={() => {
            setModalFlag(false);
          }}
        />
      </div>

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </>
  );
};

export default EditTicket;
